// FIXTURE / FAKE keys (sourcemap-only)
const api_key = 'fixture-sourcemap-only-key-7f3c9a1b2d';
export const ADMIN_CONFIG_URL = '/internal/admin/config';
